// extracted by mini-css-extract-plugin
module.exports = {"content":"Tooltip_content__shpSL","arrow":"Tooltip_arrow__srZbV"};